import Vue from 'vue/dist/vue.esm';

export default Vue.component('mediaselectormodal', {

});